import React, { useState } from 'react';
import { api } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Save, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const AdminPassword = () => {
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm: '' });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }
    if (form.new_password !== form.confirm) {
      toast.error('Passwords do not match');
      return;
    }
    setSaving(true);
    try {
      await api.post('/auth/change-password', {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success('Password updated');
      setForm({ current_password: '', new_password: '', confirm: '' });
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Failed');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-md">
      <h1 className="font-display text-2xl text-[#5a1d3b] mb-1" style={{ fontWeight: 500 }}>Change Password</h1>
      <p className="text-gray-500 text-sm mb-6">Update your admin password.</p>

      <form onSubmit={submit} className="bg-white border border-gray-200 rounded-xl p-6 space-y-4">
        <div>
          <Label className="mb-2 block text-sm">Current password</Label>
          <Input type="password" required value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} className="h-11" />
        </div>
        <div>
          <Label className="mb-2 block text-sm">New password</Label>
          <Input type="password" required value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} className="h-11" />
        </div>
        <div>
          <Label className="mb-2 block text-sm">Confirm new password</Label>
          <Input type="password" required value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className="h-11" />
        </div>
        <Button type="submit" disabled={saving} className="w-full bg-[#c4477a] hover:bg-[#a83668] text-white rounded-full h-12 gap-2">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
          Update Password
        </Button>
      </form>
    </div>
  );
};

export default AdminPassword;
